export default "__VITE_PUBLIC_ASSET__5bd72c4a__"